<template>
	<q-page padding>
		<div class="q-display-1 q-mb-md text-secondary">
			<span>
				<q-icon name="fas fa-list" class="q-mb-sm" /> {{ $t(title_trainings) }}
				<q-tooltip anchor="bottom right" self="top left">
					{{ $t('trainings_helper') }}
				</q-tooltip>
			</span>
		</div>

		<filters class="filter-card" :options="getOptionsFilter" @requestFiltered="requestFiltered"
			@clearAndRequest="clearAndRequest" />

		<q-table :data="trainings" :columns="columns" :pagination.sync="server_pagination" @request="request"
			:loading="loading" :filter="filter" row-key="id" :no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')" :loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')" :rows-per-page-options="[5, 10, 50, 100]" binary-state-sort>
			<template slot="top" slot-scope="props" :props="props">
				<q-search v-model="filter" :debounce="600" icon="fas fa-search" :placeholder="$t('search')" />

				<div class="col" />
				<!-- <q-btn-dropdown color="secondary" :label="$t('reports_bi')" class="q-mr-sm" ref="dropdownReport" v-if="report_list.length > 0 && permissions.reports">
					<q-list highlight separator link>
						<q-item 							v-for="(report, index) in report_list"
							:key="`i${index}`"
							@click.native="showReportBI(report)">
							<q-item-main>
								{{ $t(report.slug) }}
							</q-item-main>
						</q-item>
					</q-list>
				</q-btn-dropdown> -->
				<q-btn color="secondary" v-if="login_use_portfolio_page && permissions.trainings_manage" class="q-mr-sm"
					icon="fas fa-images" :label="$t('sort_portfolio')"
					@click="show_portfolio_ordering = true" />
				<q-btn color="secondary" v-if="permissions.reports"
					:disable="$buttonDelay('courses_report_button_delay')" class="q-mr-sm" icon="fas fa-download"
					:label="$t('training_report')" @click="downloadReport()">
					<q-tooltip v-if="$buttonDelay('courses_report_button_delay')" anchor="top middle"
						self="bottom middle" :offset="[5, 5]">
						{{ $t('report_button_delay') }}
					</q-tooltip>
				</q-btn>
				<q-btn color="secondary" icon="fas fa-plus" :label="$t('new')"
					@click="$router.push({ name: 'admin_training', params: { id: 0 } })"
					:disable="!permissions.trainings_manage" />
			</template>

			<q-tr slot="header" slot-scope="props" :props="props">
				<q-th v-for="col in props.cols" :key="col.name" :props="props" v-show="col.show">
					{{ $t(col.label) }}
				</q-th>
			</q-tr>

			<q-tr slot="body" slot-scope="props" :props="props">
				<q-td auto-width key="id" :props="props" v-show="showColumn(props.colsMap, 'id')">
					{{ props.row.id }}
				</q-td>

				<q-td key="title" :props="props" v-show="showColumn(props.colsMap, 'title')">
					<span v-if="props.row.title.length > 49">
						{{ `${props.row.title.substring(0, 50)}...` }}
						<q-tooltip>{{ props.row.title }}</q-tooltip>
					</span>
					<span v-else>
						{{ props.row.title }}
					</span>
				</q-td>

				<q-td auto-width key="code" :props="props" v-show="showColumn(props.colsMap, 'code')">
					{{ props.row.code }}
				</q-td>

				<q-td key="permission" :props="props" v-show="showColumn(props.colsMap, 'permission')">
					<q-btn color="primary" text-color="white" :label="getQuantity(props.row.permission)" no-ripple>
						<q-tooltip>
							<p v-if="props.row.permission.areas.length > 0" class="tooltip q-mb-sm">
								{{ $t('areas') }}:
								<span v-for="(area, index) in props.row.permission.areas" :key="index">
									{{ getArea(area) }}
									<span v-if="props.row.permission.areas.length - 1 > index">,
									</span>
								</span>
							</p>
							<p v-if="props.row.permission.clients.length > 0" class="tooltip q-mb-sm">
								{{ $t('clients') }}:
								<span v-for="(client, index) in props.row.permission.clients" :key="index">
									{{ getClient(client) }}
									<span v-if="props.row.permission.clients.length - 1 > index">,
									</span>
								</span>
							</p>
							<p v-if="props.row.permission.user_groups.length > 0" class="tooltip q-mb-sm">
								{{ $t('user_groups') }}:
								<span v-for="(user_group, index) in props.row.permission.user_groups" :key="index">
									{{ getUserGroup(user_group) }}
									<span v-if="props.row.permission.user_groups.length - 1 > index">,
									</span>
								</span>
							</p>
							<p v-if="props.row.permission.profiles.length > 0" class="tooltip q-mb-sm">
								{{ $t('profiles') }}:
								<span v-for="(profile, index) in props.row.permission.profiles" :key="index">
									{{ getUserProfile(profile) }}
									<span v-if="props.row.permission.profiles.length - 1 > index">,
									</span>
								</span>
							</p>
						</q-tooltip>
					</q-btn>
				</q-td>

				<q-td key="tags" :props="props" v-show="showColumn(props.colsMap, 'tags')">
					<q-btn color="primary" text-color="white" :label="getQuantityTags(props.row.tags)" no-ripple>
						<q-tooltip v-if="props.row.tags.length > 0">
							<p class="tooltip q-mb-sm">
								{{ $t('tags') }}:
								<span v-for="(tag, index) in props.row.tags" :key="index">
									{{ getTag(tag) }}
									<span v-if="props.row.tags.length - 1 > index">, </span>
								</span>
							</p>
						</q-tooltip>
					</q-btn>
				</q-td>

				<q-td key="owners" :props="props" v-show="showColumn(props.colsMap, 'owners')">
					<q-btn color="primary" text-color="white" :label="props.row.owners.length" no-ripple>
						<q-tooltip v-if="props.row.owners.length > 0">
							<p class="tooltip q-mb-sm">
								{{ $t('owners') }}:
								<span v-for="(owner, index) in props.row.owners" :key="index">
									{{ owner }}
									<span v-if="props.row.owners.length - 1 > index">, </span>
								</span>
							</p>
						</q-tooltip>
					</q-btn>
				</q-td>

				<q-td key="total_score" :props="props" v-show="showColumn(props.colsMap, 'total_score')">
					{{ props.row.total_score }}
				</q-td>

				<q-td key="qty_group_training_modules" :props="props"
					v-show="showColumn(props.colsMap, 'qty_group_training_modules')">
					{{ props.row.qty_group_training_modules }}
				</q-td>

				<q-td key="qty_group_training_tests" :props="props"
					v-show="showColumn(props.colsMap, 'qty_group_training_tests')">
					{{ props.row.qty_group_training_tests }}
				</q-td>

				<q-td key="created_date" :props="props" v-show="showColumn(props.colsMap, 'created_date')">
					{{ props.row.created_date }}
				</q-td>

				<q-td key="updated_date" :props="props" v-show="showColumn(props.colsMap, 'updated_date')">
					{{ props.row.updated_date }}
				</q-td>

				<q-td key="unpublish_date" :props="props" v-show="showColumn(props.colsMap, 'unpublish_date')">
					{{ props.row.unpublish_date }}
				</q-td>

				<q-td key="is_open" :props="props" auto-width v-show="showColumn(props.colsMap, 'is_open')">
					<q-chip small :icon="getIconIsOpen(props.row)" :color="getColorIsOpen(props.row)"
						class="full-width">
						{{ $t(getIsOpen(props.row)) }}
					</q-chip>
				</q-td>

				<q-td key="status" :props="props" auto-width v-show="showColumn(props.colsMap, 'status')">
					<q-chip small :icon="getIconStatus(props.row)" :color="getColorStatus(props.row)"
						class="full-width">
						{{ $t(getStatus(props.row)) }}
					</q-chip>
				</q-td>

				<q-td auto-width key="actions" :props="props" v-show="showColumn(props.colsMap, 'actions')">
					<q-btn flat round color="primary" icon="fas fa-pencil-alt" @click="
					$router.push({
						name: 'admin_training',
						params: { id: props.row.actions },
					})
					">
						<q-tooltip>
							{{ $t('view_or_edit_tooltip') }}
						</q-tooltip>
					</q-btn>

					<q-btn flat round color="secondary" icon="fas fa-chart-line" @click="showTrainingReport(props.row)">
						<q-tooltip>
							{{ $t('view_report_for_this_training_tooltip') }}
						</q-tooltip>
					</q-btn>

					<q-btn flat round color="negative" icon="far fa-trash-alt" @click="confirmRemove(props.row.actions)"
						:disable="!permissions.trainings_manage">
						<q-tooltip>
							{{ $t('delete_tooltip') }}
						</q-tooltip>
					</q-btn>
				</q-td>
			</q-tr>

			<q-tr slot="bottom-row" slot-scope="props" :props="props">
				<q-td colspan="100%">
					<q-btn flat round dense color="secondary" size="small" icon="fas fa-cog"
						@click="show_customize_columns = true">
						<q-tooltip>
							{{ $t('configure_table_tooltip') }}
						</q-tooltip>
					</q-btn>
				</q-td>
			</q-tr>
		</q-table>

		<q-dialog v-model="confirm_remove" @ok="removeItem">
			<span slot="title">{{ $t('remove_item') }}</span>

			<span slot="message">{{ $t('confirm_remove_item') }}</span>

			<template slot="buttons" slot-scope="props" :props="props">
				<q-btn color="primary" :label="$t('cancel')" @click="confirm_remove = false" />
				<q-btn color="negative" :label="$t('remove')" @click="removeItem()" />
			</template>
		</q-dialog>

		<q-modal v-model="show_customize_columns"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }">
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="saveColumns()" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('personalize_columns') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div class="row gutter-md">
						<div class="col-xs-12 col-sm-4" v-for="(column, index) in columns" :key="index"
							v-if="column.label && column.label != '#'">
							<q-checkbox v-model="column.show" :label="$t(column.label)" />
						</div>
					</div>

					<div class="row reverse gutter-md q-mt-md">
						<div class="col-xs-12 col-sm-3">
							<q-btn icon="fas fa-times" color="primary" class="fit" :label="$t('close')"
								@click="saveColumns()" />
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-modal v-model="show_report" :content-css="{ minWidth: '100vw', maxWidth: '100vw', minHeight: '100vh' }">
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="show_report = false" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('reports') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div style="position:relative; width:100%; height:0px; padding-bottom:56.25%;">
						<iframe style="position:absolute; left:0; top:0; width:100%; height:100%" :src="report_url"
							frameborder="0">
						</iframe>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-modal v-model="show_report" :content-css="{ minWidth: '100vw', maxWidth: '100vw', minHeight: '100vh' }">
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="show_report = false" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('reports') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div style="position:relative; width:100%; height:0px; padding-bottom:56.25%;">
						<iframe style="position:absolute; left:0; top:0; width:100%; height:100%" :src="report_url"
							frameborder="0">
						</iframe>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-dialog v-model="show_report_problem" prevent-close>
			<span slot="title">{{ $t('report_download_failed') }}</span>

			<div slot="message">
				<span class="q-pa-xs">{{ $t('report_download_failed_exceeded_time') }}</span>
				<p class="q-pa-xs">{{ $t('the_report_it_will_be_sent_to_your_email') }}</p>
			</div>

			<template slot="buttons" slot-scope="props" :props="props" class="justify-center">
				<div class="row full-width q-mb-xs">
					<q-btn color="positive" class="offset-4 col-4" :label="$t('ok')"
						@click="show_report_problem = false" />
				</div>
			</template>
		</q-dialog>

		<reports v-if="show_report_training" :show_report_training="show_report_training" :id="action_id"
			:status="action_status" :title="action_title" @hide_report="hideReport()" />

		<portfolio-ordering v-if="show_portfolio_ordering" :show_portfolio_ordering="show_portfolio_ordering"
			@hide_portfolio_modal="hidePortfolioModal()" />
	</q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { LocalStorage } from 'quasar'
import { date } from 'quasar'
import * as moment from 'moment'
import * as tz from 'moment-timezone'
import NotificateUsers from 'components/admin/trainings/NotificateUsers.vue'
import Filters from 'components/admin/trainings/Filters.vue'

export default {
	name: 'AdminTrainings',

	i18nOptions: {
		namespaces: [
			'custom',
			'training',
			'games',
			'common',
			'admin',
			'courses',
			'imports',
			'overview',
		],
	},

	components: {
		reports: () => import('components/admin/trainings/Report.vue'),
		'portfolio-ordering': () => import('components/admin/trainings/PortfolioOrdering.vue'),
		'notificate-users': NotificateUsers,
		filters: Filters,
	},

	data() {
		return {
			server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: 5,
				descending: false,
				sortBy: null,
			},
			loading: false,
			trainings: [],
			columns: [
				{
					name: 'id',
					required: true,
					label: '#',
					align: 'left',
					field: 'id',
					sortable: true,
					show: true,
				},
				{
					name: 'title',
					required: true,
					label: 'training',
					align: 'left',
					field: 'title',
					sortable: true,
					show: true,
				},
				{
					name: 'code',
					required: true,
					label: 'code',
					align: 'left',
					field: 'code',
					sortable: true,
					show: false,
				},
				{
					name: 'permission',
					required: true,
					label: 'permission',
					align: 'left',
					field: 'permission',
					sortable: false,
					show: false,
				},
				{
					name: 'tags',
					required: true,
					label: 'tags',
					align: 'left',
					field: 'tags',
					sortable: false,
					show: true,
				},
				{
					name: 'owners',
					required: true,
					label: 'owners',
					align: 'left',
					field: 'owners',
					sortable: false,
					show: true,
				},
				{
					name: 'total_score',
					required: true,
					label: 'score',
					align: 'left',
					field: 'total_score',
					sortable: true,
					show: false,
				},
				{
					name: 'qty_group_training_modules',
					required: true,
					label: 'classes',
					align: 'left',
					field: 'qty_group_training_modules',
					sortable: true,
					show: true,
				},
				{
					name: 'qty_group_training_tests',
					required: true,
					label: 'tests',
					align: 'left',
					field: 'qty_group_training_tests',
					sortable: true,
					show: true,
				},
				{
					name: 'created_date',
					required: true,
					label: 'created_date',
					align: 'left',
					field: 'created_date',
					sortable: true,
					show: true,
				},
				{
					name: 'updated_date',
					required: true,
					label: 'updated_date',
					align: 'left',
					field: 'updated_date',
					sortable: true,
					show: true,
				},
				{
					name: 'unpublish_date',
					required: true,
					label: 'unpublish_date',
					align: 'left',
					field: 'unpublish_date',
					sortable: true,
					show: true,
				},
				{
					name: 'is_open',
					required: true,
					label: 'open_training',
					align: 'left',
					field: 'is_open',
					sortable: true,
					show: true,
				},
				{
					name: 'status',
					required: true,
					label: 'status',
					align: 'left',
					field: 'status',
					sortable: true,
					show: true,
				},
				{
					name: 'actions',
					required: true,
					label: '',
					align: 'right',
					field: 'edit',
					sortable: false,
					show: true,
				},
			],
			filter: '',
			filter_area: [],
			filter_profile: [],
			filter_user_group: [],
			filter_status: [],
			filter_tag: [],
			filter_start_date: [],
			filter_end_date: [],
			action_id: '',
			action_status: '',
			action_title: '',
			confirm_remove: false,
			show_report: false,
			report_url: '',
			dropdown_reports: false,
			show_portfolio_ordering: false,
			show_report_training: false,
			show_report_problem: false,
			show_customize_columns: false,
			permissions: {
				trainings_manage: false,
				reports: false,
				reports_panel: false,
			},
			show_report: false,
			report_list: [],
			report_url: '',
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			areas: 'registration_lists/country_areas',
			clients: 'params/clients',
			id_user_client_country_selected: 'common/id_user_client_country_selected',
			id_user_client_selected: 'common/id_user_client_selected',
			login_use_portfolio_page: 'params/login_use_portfolio_page',
			num_rows: 'datatable/num_rows',
			profiles: 'registration_lists/profiles',
			reload_content: 'common/reload_content',
			reports: 'registration_lists/reports',
			tags: 'registration_lists/tags',
			trainings_columns: 'datatable_columns/trainings_columns',
			user_client_module_items: 'common/user_client_module_items',
			user_clients: 'common/user_clients',
			user_groups: 'registration_lists/group_users',
			trainings_filters: 'admin_filters/trainings_filters',
			reports_store: 'registration_lists/reports',
		}),

		getOptionsFilter() {
			return {
				areas: this.areas ? this.areas : [],
				profiles: this.profiles ? this.profiles : [],
				user_groups: this.user_groups ? this.user_groups : [],
				statuses: [
					{ value: 1, label: this.$t('published') },
					{ value: 2, label: this.$t('unpublished') },
				],
				tags: this.tags ? this.tags : [],
			}
		},

		title_trainings() {
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					return obj.title_trainings == '' ? 'trainings' : obj.title_trainings
				}
			}
		},

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '80vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},

		filteredReports() {
			let obj = this.reports.filter((obj) => {
				return (
					obj.slug_type === 'group_trainings' &&
					obj.url != 'https://www.take5.com.br' &&
					obj.url != ''
				)
			})
			return obj
		},
		haveFilter() {
			for (const property in this.trainings_filters) {
				if (this.trainings_filters[property].length > 0) return true
			}
			return false
		},
	},

	methods: {
		request({ pagination }) {
			this.loading = true
			this.server_pagination = pagination

			let order = pagination.descending ? '-' : ''
			let order_by = pagination.sortBy ? order + pagination.sortBy : ''

			let data = {
				page_size: this.server_pagination.rowsPerPage,
				page: this.server_pagination.page,
				area: this.filter_area,
				profile: this.filter_profile,
				user_group: this.filter_user_group,
				status: this.filter_status,
				tag: this.filter_tag,
				start_date: this.filter_start_date,
				end_date: this.filter_end_date,
				search: this.filter,
				ordering: order_by,
			}

			this.savePagination()

			this.$axios
				.get(
					`/admin_group_trainings/group_trainings/?${this.$qs.stringify(data, {
						arrayFormat: 'repeat',
					})}`,
					this.getHeader
				)
				.then((response) => {
					this.server_pagination.rowsNumber = response.data.count

					this.trainings = []

					this.trainings = response.data.results.map((r) => {
						return {
							...r,
							created_date: date.formatDate(r.created_date, 'DD/MM/YYYY HH:mm'),
							updated_date: date.formatDate(r.updated_date, 'DD/MM/YYYY HH:mm'),
							unpublish_date: r.unpublish_date
								? moment(r.unpublish_date)
									.tz('Etc/GMT')
									.format('DD/MM/YYYY')
								: '',
							owners: r.owners_list.map((o) => o.full_name),
							actions: r.id,
							permission: {
								areas: r.areas,
								profiles: r.profiles,
								clients: r.clients,
								user_groups: r.user_groups,
							},
						}
					})

					this.loading = false
				})
				.catch((e) => {
					this.loading = false
					console.log(e)
				})
		},

		fetchLists() {
			this.$q.loading.show()

			this.$axios
				.get('/accounts/get_registration_lists/', this.getHeader)
				.then((response) => {
					this.$store.dispatch('registration_lists/SET_LISTS', [response.data])
					this.$q.loading.hide()

					if (this.haveFilter) {
						this.requestFiltered()
					} else {
						this.request({
							pagination: this.server_pagination,
						})
					}
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		clearAndRequest() {
			this.filter_area = []
			this.filter_profile = []
			this.filter_status = []
			this.filter_tag = []
			this.filter_start_date = []
			this.filter_end_date = []

			this.request({
				pagination: {
					page: 1,
					rowsNumber: 10,
					rowsPerPage: this.num_rows,
					descending: false,
					sortBy: null,
				},
			})
		},

		requestFiltered() {
			this.filter_area = this.trainings_filters.area
			this.filter_profile = this.trainings_filters.profile
			this.filter_user_group = this.trainings_filters.user_group
			this.filter_status = this.trainings_filters.status
			this.filter_tag = this.trainings_filters.tag
			this.filter_start_date = [
				date.formatDate(this.trainings_filters.start_date_display, 'YYYY-MM-DD-HH-mm-ss'),
			]
			this.filter_end_date = [
				date.formatDate(this.trainings_filters.end_date_display, 'YYYY-MM-DD-HH-mm-ss'),
			]

			this.request({
				pagination: {
					page: 1,
					rowsNumber: 10,
					rowsPerPage: this.num_rows,
					descending: false,
					sortBy: null,
				},
			})
		},

		showTrainingReport(training) {
			this.action_id = training.id
			this.action_status = training.status
			this.action_title = training.title
			this.show_report_training = true
		},

		hideReport() {
			this.action_id = ''
			this.show_report_training = false
			this.loadPagination()
		},

		hidePortfolioModal() {
			this.show_portfolio_ordering = false
			this.loadPagination()
		},

		showColumn(list, name) {
			if (list[name]) return list[name].show
			else return false
		},

		saveColumns() {
			this.show_customize_columns = false
			this.saveDatatableColumns()
		},

		confirmRemove(id) {
			this.action_id = id
			this.confirm_remove = true
		},

		removeItem() {
			this.$q.loading.show()

			this.$axios
				.delete(`/admin_group_trainings/group_trainings/${this.action_id}/`, this.getHeader)
				.then((response) => {
					this.$q.loading.hide()

					this.request({
						pagination: this.server_pagination,
					})

					this.confirm_remove = false

					this.$q.notify({
						message: this.$t('item_removed_success'),
						type: 'positive',
						icon: 'far fa-trash-alt',
					})
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		getFeatured(featured) {
			if (featured == 1) return 'yes'
			else return 'no'
		},

		getIsOpen(row) {
			if (row.is_open) {
				return 'yes'
			} return 'no'
		},

		getIconIsOpen(row) {
			if (row.is_open) {
				return 'fas fa-clock'
			} return 'fas fa-ban'
		},

		getColorIsOpen(row) {
			if (row.is_open) {
				return 'positive'
			} return 'grey-8'
		},


		getStatus(row) {
			if (row.status == 1) {
				if (!row.is_open) return 'published'
				else return 'open'
			} else if (row.status == 2) return 'unpublished'
			else if (row.status == 3) return 'deleted_f'
			else if (row.status == 4) return 'processing'
			else if (row.status == 5) return 'processing'
		},

		getIconStatus(row) {
			if (row.status == 1) {
				if (!row.is_open) return 'fas fa-check'
				else return 'fas fa-clock'
			} else if (row.status == 2) return 'fas fa-ban'
			else if (row.status == 3) return 'fas fa-trash-alt'
			else if (row.status == 4) return 'fas fa-sync fa-spin'
			else if (row.status == 5) return 'fas fa-sync fa-spin'
		},

		getColorStatus(row) {
			if (row.status == 1) {
				if (!row.is_open) return 'positive'
				else return 'info'
			} else if (row.status == 2) return 'warning'
			else if (row.status == 3) return 'negative'
			else if (row.status == 4) return 'info'
			else if (row.status == 5) return 'info'
		},

		getKnowledgeArea(id) {
			let area = this.areas.find((obj) => {
				return obj.value === id
			})
			if (area) return area.label
			else return ''
		},

		getQuantity(permission) {
			return (
				permission.areas.length +
				permission.clients.length +
				permission.user_groups.length +
				permission.profiles.length
			)
		},

		getArea(area) {
			let obj = this.areas.find((obj) => {
				return obj.value === area
			})
			if (obj) return obj.label
			else return ''
		},

		getClient(client) {
			if (this.user_clients) {
				let obj = this.user_clients.find((obj) => {
					return obj.id === client
				})
				if (obj) return obj.name
			}
			return ''
		},

		getUserGroup(user_group) {
			let obj = this.user_groups.find((obj) => {
				return obj.value === user_group
			})
			if (obj) return obj.label
			else return ''
		},

		getUserProfile(profile) {
			let obj = this.profiles.find((obj) => {
				return obj.value === profile
			})
			if (obj) return obj.label
			else return ''
		},

		getQuantityTags(tags) {
			return tags.length > 0 ? tags.length : '0'
		},

		getTag(tag) {
			let obj = this.tags.find((obj) => {
				return obj.value === tag
			})
			if (obj) return obj.label
			else return ''
		},

		showReport(report) {
			this.report_url = report.url
			this.dropdown_reports = false
			this.show_report = true
		},

		savePagination() {
			this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
		},

		loadPagination() {
			this.server_pagination.rowsPerPage = this.num_rows
		},

		saveDatatableColumns() {
			this.$store.dispatch('datatable_columns/SET_TRAININGS_COLUMNS', [this.columns])
		},

		loadDatatableColumns() {
			if (process.env.PROJECT_FOLDER !== 'universidadechevrolet') {
				this.columns = this.columns.filter((c) => c.name !== 'code')

				const storedCol = this.trainings_columns.find((c) => c.name === 'code')
				if (storedCol) {
					this.$store.dispatch('datatable_columns/SET_TRAININGS_COLUMNS', [this.columns])
				}
			}
			if (this.$compareStoredColumns(this.columns, this.trainings_columns))
				this.columns = this.trainings_columns
			else return
		},

		downloadReport() {
			if (this.$buttonDelay('courses_report_button_delay')) return
			let message = this.$t('generating_import_file_message')
			this.$q.loading.show({
				message,
			})
			this.$axios
				.get(`admin_group_trainings/group_trainings/generate_report/`, this.getHeader)
				.then((response) => {
					this.forceFileDownload(response.data.path_url)
				})
				.catch((e) => {
					this.loading = false
					this.show_report_problem = true
					console.log(e)
				})
				.finally(() => {
					this.$store.dispatch('common/SET_COURSES_REPORT_BUTTON_DELAY', [new Date()])
					this.$q.loading.hide()
				})
		},

		forceFileDownload(response) {
			const link = document.createElement('a')
			link.href = response
			document.body.appendChild(link)
			link.click()
		},

		checkPermissions() {
			const client = this.user_client_module_items.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (client) {
				for (const [key, value] of Object.entries(this.permissions)) {
					let obj = client.module_items.find((obj) => obj.slug === key)
					if (obj) {
						this.permissions[key] = obj.permission
					}
				}
			} else return
		},

		loadReports() {
			if (this.reports_store)
				this.report_list = this.reports_store.filter((obj) => {
					return (
						obj.slug_type === 'group_trainings' &&
						obj.url != 'https://www.take5.com.br' &&
						obj.url != ''
					)
				})
		},

		getAuthParamsData(url_original) {
			this.$q.loading.show()
			this.$axios
				.get('/reports/reports/get_looker_studio_challenge_token/', this.getHeader)
				.then((response) => {
					this.report_url = `${url_original}?${response.data.params}`
					this.show_report = true
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		showReportBI(report) {
			this.$refs.dropdownReport.hide()
			if (report.report_type === 3) {
				this.getAuthParamsData(report.url_original)
			} else {
				this.report_url = report.url
				this.show_report = true
			}
		},
	},

	watch: {
		reload_content: function () {
			this.request({
				pagination: this.server_pagination,
			})
		},
	},

	created() {
		this.loadReports()
		this.loadDatatableColumns()
		this.loadPagination()
		this.fetchLists()
		this.checkPermissions()
	},
}
</script>

<style lang="stylus" scoped>
.filter-card
    border-radius 4px
    box-shadow 0 1px 2px rgba(0,0,0,0.2), 0 1px 1px rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12)
</style>
